import { useState } from 'react';
import { motion } from 'framer-motion';
import AgentPicker from './AgentPicker';

const examples = [
  'Habit tracker for remote workers',
  'Invoice app for freelancers',
  'Daily standup bot for 2-person teams',
];

const InputCard = ({ onSubmit, initialIdea = '' }) => {
  const [idea, setIdea] = useState(initialIdea);
  const [selectedAgent, setSelectedAgent] = useState('auto');
  const maxChars = 500;
  const minChars = 8;

  const handleSubmit = () => {
    if (idea.length >= minChars) {
      localStorage.setItem('1prompt_selected_agent', selectedAgent);
      onSubmit(idea);
    }
  };

  return (
    <div className="w-full max-w-3xl mx-auto space-y-6">
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="relative rounded-2xl bg-white border border-[#E2E8F0] p-6"
        style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}
        data-testid="landing-input-card"
      >
        <textarea
          value={idea}
          onChange={(e) => setIdea(e.target.value.slice(0, maxChars))}
          placeholder="Describe your app in one sentence..."
          className="w-full bg-transparent text-[#0F172A] text-lg leading-relaxed resize-none outline-none placeholder:text-[#94A3B8]"
          rows={3}
          data-testid="landing-input-textarea"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
              handleSubmit();
            }
          }}
        />

        <div className="mt-4 flex items-center justify-between">
          <AgentPicker value={selectedAgent} onChange={setSelectedAgent} />

          <div className="flex items-center gap-4">
            {idea.length > 0 && (
              <motion.span
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                className="text-sm text-[#94A3B8]"
              >
                {idea.length}/{maxChars}
              </motion.span>
            )}

            <button
              onClick={handleSubmit}
              disabled={idea.length < minChars}
              data-testid="landing-grow-button"
              className="px-6 py-2.5 rounded-lg bg-[#2563EB] hover:bg-[#1D4ED8] disabled:bg-[#E2E8F0] disabled:text-[#94A3B8] disabled:cursor-not-allowed text-white font-semibold transition-all"
              style={{ boxShadow: idea.length >= minChars ? '0 4px 14px 0 rgba(37, 99, 235, 0.39)' : 'none' }}
            >
              Build
            </button>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="flex flex-wrap gap-3 justify-center"
      >
        {examples.map((example) => (
          <button
            key={example}
            onClick={() => setIdea(example)}
            data-testid={`landing-example-${example.split(' ').slice(0, 2).join('-').toLowerCase()}`}
            className="px-4 py-2 rounded-full border border-[#E2E8F0] bg-white text-sm text-[#475569] font-medium cursor-pointer"
          >
            {example}
          </button>
        ))}
      </motion.div>
    </div>
  );
};

export default InputCard;
